<template>
  <div fluid @click="$emit('paymentSelected', payment)">
    <v-row class="payment-single">
      <v-col class="d-flex align-center" cols="2" sm="1">
        <v-icon>{{ payment.icon || 'mdi-cash-usd-outline' }}</v-icon>
      </v-col>
      <v-col v-if="payment.id === 'CHECK'" class="d-flex align-center" cols="2" sm="9">
        <img width="auto" height="40" :src="require('@/assets/mercadopagologo.png')" />
        <div v-if="payment.id == 'CHECK'" class="checkout-container d-flex align-center ml-5">
          <span>{{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.accountMoney') }}</span>
        </div>
        <div v-if="payment.id == 'CHECK' && $isTeclab" class="checkout-container d-flex align-center ml-2">
          <span>{{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.CreditMP') }}</span>
      </div>
      </v-col>
      <v-col v-if="payment.id === 'GETNET'" class="d-flex align-center" cols="2" sm="9">
        <img width="auto" height="25" :src="require('@/assets/santanderlogo.png')" />
        <div v-if="promotions.length" class="promotion-container">
          <div 
            v-for="(promotion, index) in formattedPromotions" 
            :key="index" 
            class="promotion-text"
            v-html="promotion"
            :class="{ 'last-promotion': index === promotions.length - 1 }">
          </div>
        </div>
      </v-col>

      <v-col v-if="payment.id === 'WIBOND'" class="d-flex align-center" cols="2" sm="9">
        <img width="auto" height="60" :src="require('@/assets/wibondlogo.png')" />
      </v-col>

      <v-col v-if="payment.id === 'GOCUOTAS'" class="d-flex align-center" cols="2" sm="9">
        <img width="auto" height="60" :src="require('@/assets/gocuotaslogo.png')" />
      </v-col>

      <v-col v-if="payment.id != 'CHECK' && payment.id != 'GETNET' && payment.id != 'WIBOND' && payment.id != 'GOCUOTAS'"  class="description d-flex flex-column justify-center" cols="8" sm="9">
        <span>{{ payment.name }}</span>
        <span class="subdescription" :class="{ 'green--text': payment.color == 'green' }" v-if="payment.description">{{ payment.description }}</span>
      </v-col>
      <v-col class="arrow-container d-flex align-center justify-end text-right" cols="2">
        <v-icon>mdi-chevron-right</v-icon>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    payment: Object
  },
  computed: {
    formattedPromotions() {
      return this.promotions.map(promotion => 
      promotion
        .replace('3 CUOTAS', '<strong style="font-size: 14px">3 CUOTAS</strong>')
        .replace('6 CUOTAS', '<strong style="font-size: 14px">6 CUOTAS</strong>')
        .replace('12 CUOTAS', '<strong style="font-size: 14px">12 CUOTAS</strong>')
    );
    }
  },
  data() {
    return {
      promotions: [
        // 'TODOS LOS JUEVES\n3 CUOTAS \nsin interés',
        'DEL 12 al 18 de MAYO \n <strong style="font-size: 12px">SOLO CON VISA CUOTAS</strong> \nsin interés'
      ]
    }
  }
}
</script>

<style scoped lang="sass">
.description
  span
    font-family: 'DM Sans'
    font-size: 16px
    line-height: 1.2
    font-weight: bold
    letter-spacing: -0.48px
    color: #212121
    margin-bottom: 0

    &.subdescription
      -webkit-text-stroke: 1px rgba(0, 0, 0, 0)
      font-family: 'Roboto'
      font-size: 12px
      line-height: 1.2
      font-weight: bold
      margin-bottom: 0

.promotion-container 
  display: flex
  justify-content: flex-end  
  align-items: center
  text-align: center
  margin-left: auto

.promotion-text 
  padding: 8px
  background: #EA1D25
  border-radius: 4px
  color: white 
  font-family: Roboto
  margin-right: 5px
  font-size: 10px
  font-weight: 400
  line-height: 1.2
  white-space: pre-line
  overflow: hidden
  width: 160px 
  height: 60px 

.checkout-container
  color: #2b81ff
  padding: 4px 8px
  background: #e2edf4
  border-radius: 4px
  border: 1px solid #2b81ff
  font-family: 'Roboto', sans-serif
  font-size: 0.85rem
  font-weight: 400
  white-space: nowrap

.arrow-container
  font-family: 'DM Sans'
  font-size: 20px
  font-weight: bold
  letter-spacing: -0.6px
  color: #212121

.payment-single
  height: 90px
  border-radius: 5px
  box-shadow: 0 2px 2px 0 rgba(1, 33, 105, 0)
  border: solid 1px #d9d9d9
  background-color: white
  margin-bottom: 5px !important
  margin-top: 5px

  &:first-of-type
    margin-top: 0 

  &:hover
    box-shadow: 0 8px 14px 0 rgba(0, 44, 142, 0.15)
    border: solid 1px #0036b1
    cursor: pointer
</style>
